<template>
  <div class="template">
    <div class="search">
      <div>
        <Input
          v-model="search.name"
          placeholder="请输入机构名称"
          style="width: 310px; margin-right: 10px"
          icon="ios-search"
        ></Input>
        <Button style="width: 90px" type="primary" icon="ios-search" @click="searchFn">搜索</Button>
      </div>
      <Button type="primary" @click="$router.push({ name: 'add-organization' })">添加机构</Button>
    </div>
    <div class="filter">
      <div class="filter-item">
        <span class="title">手机号</span>
        <Input style="width: 200px" v-model="search.mobile" placeholder="请输入手机号"></Input>
      </div>
      <div class="filter-item">
        <span class="title">状态</span>
        <Select v-model="search.status" style="width: 200px" placeholder="请选择状态">
          <Option label="全部" value=""></Option>
          <Option label="无效" value="0"></Option>
          <Option label="有效" value="1"></Option>
          <Option label="冻结" value="2"></Option>
        </Select>
      </div>
      <div class="filter-item">
        <span class="title">合作方式</span>
        <Select v-model="search.type" style="width: 200px" placeholder="请选择合作方式">
          <Option label="全部" value=""></Option>
          <Option label="购买" value="1"></Option>
          <Option label="服务" value="2"></Option>
        </Select>
      </div>
      <div class="filter-item">
        <Button style="width: 90px" type="primary" icon="ios-search" @click="searchFn">搜索</Button>
        <Button style="width: 90px; margin-left: 10px" @click="clearFn">清空</Button>
      </div>
    </div>
    <div class="table">
      <Table border :columns="diyData.columns" :data="apiData.tableList">
        <template slot="footer">
          <Page
            :total="apiData.total"
            show-total
            :page-size="15"
            :current="search.page"
            class-name="footer-page"
            @on-change="pageChange"
          ></Page>
        </template>
      </Table>
    </div>
  </div>
</template>

<script>
import { apiOrganizationList, apiOrganizationDelete, apiOrganizationNoAuth } from '@/api/organization'

export default {
  name: 'organization',
  data () {
    return {
      query: {},
      search: {
        mobile: '',
        name: '',
        status: '',
        type: '',
        page: 1
      },
      diyDom: {},
      diyData: {
        columns: [
          {
            title: '序号',
            key: '',
            render: (h, params) => {
              return h('div', params.index + 1)
            }
          },
          {
            title: '机构名称',
            key: 'name'
          },
          {
            title: '联系方式',
            key: 'mobile'
          },
          {
            title: '机构状态',
            key: '',
            render: (h, params) => {
              return h('div', [
                h('Badge', {
                  props: {
                    status: params.row.status == 1 ? 'success' : 'error'
                  }
                }),
                h('span', params.row.status_text)
              ])
            }
          },
          {
            title: '合作方式',
            key: 'type_text'
          },
          {
            title: '操作',
            fixed: 'right',
            width: 200,
            render: (h, params) => {
              return h('div', [
                h(
                  'a',
                  {
                    style: {
                      marginRight: '10px',
                      color: '#2D8cF0'
                    },
                    on: {
                      click: () => {
                        this.$router.push({
                          name: 'add-organization',
                          query: {
                            id: params.row.id
                          }
                        })
                      }
                    }
                  },
                  '编辑'
                ),
                h(
                  'a',
                  {
                    style: {
                      marginRight: '10px',
                      color: '#ed4014'
                    },
                    on: {
                      click: () => {
                        this.$Modal.confirm({
                          title: '提示',
                          content: '请确认是否删除当前机构？',
                          onOk: () => {
                            setTimeout(() => {
                              apiOrganizationDelete(params.row.id).then(res => {
                                this.$Message.success('删除成功')
                                this.getTableList()
                              })
                            }, 300)
                          }
                        })
                      }
                    }
                  },
                  '删除'
                ),
                h(
                  'a',
                  {
                    style: {
                      marginRight: '10px',
                      color: '#2D8cF0'
                    },
                    on: {
                      click: () => {
                        this.$router.push({
                          name: 'organization-config',
                          query: {
                            id: params.row.id
                          }
                        })
                      }
                    }
                  },
                  '配置'
                ),
                h(
                  'a',
                  {
                    style: {
                      marginRight: '10px',
                      color: '#2D8cF0'
                    },
                    on: {
                      click: () => {
                        this.$router.push({
                          name: 'permission-config',
                          query: {
                            id: params.row.id
                          }
                        })
                      }
                    }
                  },
                  '权限分配'
                ),
                h(
                  'a',
                  {
                    style: {
                      marginRight: '10px'
                    },
                    on: {
                      click: () => {
                        this.$store.commit('setSpinShow', true)
                        apiOrganizationNoAuth(params.row.id)
                          .then(res => {
                            let a = document.createElement('a')
                            document.body.append(a)
                            a.href = res.url
                            a.target = '_blank'
                            a.click()
                            document.body.removeChild(a)
                          })
                          .finally(() => this.$store.commit('setSpinShow', false))
                      }
                    }
                  },
                  '进入机构'
                )
              ])
            }
          }
        ]
      },
      apiData: {
        total: 0,
        tableList: []
      }
    }
  },
  methods: {
    // 获取表格数据
    getTableList () {
      this.$store.commit('setSpinShow', true)
      apiOrganizationList({
        ...this.search
      })
        .then(res => {
          const {
            data,
            meta: { pagination }
          } = res
          this.apiData.tableList = data
          this.apiData.total = pagination.total
        })
        .finally(() => this.$store.commit('setSpinShow', false))
    },
    // 分页
    pageChange (e) {
      this.search.page = e
      this.getTableList()
    },
    // 搜索
    searchFn () {
      this.search.page = 1
      this.getTableList()
    },
    // 清空
    clearFn () {
      this.search = {
        mobile: '',
        name: '',
        status: '',
        type: '',
        page: 1
      }
      this.getTableList()
    }
  },
  mounted () {
    this.getTableList()
  }
}
</script>

<style scoped lang="less">
  .template {
    .search {
      display: flex;
      justify-content: space-between;
    }

    .table {
      margin-top: 10px;
    }

    .filter {
      margin: 10px 0;
      display: flex;
      justify-content: left;
      align-items: center;
      padding: 6px 0 20px 0;
      flex-wrap: wrap;
      border: 1px solid rgba(237, 237, 237, 1);

      .filter-item {
        margin: 14px 0 0 20px;

        .title {
          margin-right: 10px;
          font-size: 12px;
          font-weight: 400;
          color: rgba(74, 74, 74, 1);
          line-height: 17px;
        }
      }
    }
  }
</style>
